import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import "../../Styles/UserAllocation.css";
import axios from "axios";
import { toast } from "react-toastify";
import {
  addNewMenu,
  addNewRole,
  agentList,
  categoryAssign,
  doctorList,
  employeeList,
  getAgentList,
  getMenuSubmenu,
  getShopOwnerList,
  productList,
  shopTypeList,
  storeAllList,
  storeTypeList,
  subServiceList,
  userCategory,
  vendorList,
} from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Section } from "../../Core/Section";

const UserAllocation = () => {
  const navigate = useNavigate();
  const [selectedReffer, setSelectedReffer] = useState("");
  const [refferList, setRefferList] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [service, setService] = useState([]);
  const [product, setProduct] = useState([]);
  const location = useLocation();
  const [userType, setUserType] = useState("");
  const [userselectId, setUserselectId] = useState("");
  const [formData,  setFormData] = useState({});
  const userId = useSelector((state) => state.user.userId);
  const [UserAllocation, setUserAllocation] = useState([]);
  const [userCategorylist, setUserCategoryList] = useState([]);
  const [cartUpdated, setUserAllocationUpdated] = useState(false);
  const { userSelectId } = location.state || {};
  const token = useSelector((state) => state.user.token);
  console.log("token : ", token);

  const [productCommission, setProductCommission] = useState([]);
  const [serviceCommission, setServiceCommission] = useState([]);
  const userTypesWithCommission = ["5", "4", "8","10","11"];
  const doctorChember = ["4"];

  const fetchRefferList = async (categoryName) => {
    console.log("categoryName : ", categoryName);
    try {
      let apiUrl = "";

      switch (categoryName) {
        case "Agent":
          setRefferList([]);
          const response1 = await agentList(token);
          console.log("response1 : ", response1);
          setRefferList(response1);
          break;
        case "Doctor":
          setRefferList([]);
          const response2 = await doctorList(token);
          console.log("response1 : ", response2);
          setRefferList(response2);
          break;
        case "Employee":
          setRefferList([]);
          const response3 = await employeeList(token);
          console.log("response1 : ", response3);
          setRefferList(response3);
          break;
        case "Shop Owner":
          setRefferList([]);
          const response4 = await shopTypeList(token);
          console.log("shopTypeList : ", response4);
          setRefferList(response4);
          break;
        case "Store Owner":
          setRefferList([]);
          const response5 = await storeTypeList(token);
          console.log("storeTypeList : ",response5)
          setRefferList(response5);
          break;
        case "Vendor":
          setRefferList([]);
          const response6 = await vendorList(token);
          console.log("response1 : ", response6);
          setRefferList(response6);
          break;
        default:
          apiUrl = "";
      }
    } catch (error) {
      console.error("Error fetching reffer list:", error);
    }
  };

  const handleAddField = (type) => {
    if (type === "product") {
      setProductCommission([
        ...productCommission,
        { name: "", commission: "" },
      ]);
    } else {
      setServiceCommission([
        ...serviceCommission,
        { name: "", commission: "" },
      ]);
    }
  };

  const handleRemoveField = (type, index) => {
    if (type === "product") {
      setProductCommission(productCommission.filter((_, i) => i !== index));
    } else {
      setServiceCommission(serviceCommission.filter((_, i) => i !== index));
    }
  };

  const handleFieldChange = (type, index, field, value) => {
    if (type === "product") {
      const updatedData = [...productCommission];
      updatedData[index][field] = value;
      setProductCommission(updatedData);
    } else  if (type === "service")  {
      const updatedData = [...serviceCommission];
      updatedData[index][field] = value;
      setServiceCommission(updatedData);
    }
  };

  console.log("userSelectId : ", userSelectId);
  useEffect(() => {
    if (userSelectId) {
      console.log("userSelectId : ", userSelectId);
      setUserselectId(userSelectId);
    }
  }, []);

  const [storeType, setStoreType] = useState([]);
  const [shopType, setShopType] = useState([]);
  const [refferedBy, setDoctor] = useState([]);
  const [storeId, setStoreId] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const[newRole,setNewRole]=useState(false)

  const [menus, setMenus] = useState([]);
const [allSubmenus, setAllSubmenus] = useState([]);
const [allPermission,setAllPermission]=useState([])

const[newRoleName,setNewRoleName]=useState("")
const [newDesc,setNewDesc]=useState("")
const [alowedMenus,setAllowedMenus]=useState([])
const [alowedSubMenus,setAllowedSubMenus]=useState([])
const[shopName,setShopName]=useState([])
const [agentListReffer,setAgentLsit]=useState([])
const [employeeRefer, setEmployee] = useState([]);
 const [storeOwnerRefer, setStoreOwner] = useState([]);
  const [vendorRefer, setVendor] = useState([]);

const handleFetchAgentList=async()=>{
  try {
    const response=await getAgentList(token)
    console.log("agents :",response.data);
    setAgentLsit(response.data)
    
  } catch (error) {
    console.log(error);
    
  }
}
    const fetchEmployeeList = async () => {
      try {
        const response = await employeeList(token);
        setEmployee(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    const fetchStoreOwner = async () => {
          try {
            const response = await storeTypeList(token);
            console.log(response);
            
            setStoreOwner(response);
          } catch (error) {
            console.error("Error:", error);
          }
        };
    const fetchVendorList = async () => {
      try {
        const response = await vendorList(token);
        console.log("Vendor : ", response);
        setVendor(response);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };
  

  const handleAddFieldMember = () => {
    setMemberList([...memberList, { id: "" }]);
  };

  const handleRemoveFieldMember = (index) => {
    const updatedList = [...memberList];
    updatedList.splice(index, 1);
    setMemberList(updatedList);
  };

  const handleMemberChange = (index, value) => {
    const updatedMembers = [...memberList];
    updatedMembers[index] = value;
    console.log("Updated store ID list:", updatedMembers);
    setMemberList(updatedMembers);
  };

  useEffect(() => {
    const fetchStoreType = async () => {
      try {
        console.log("token for store type: ", token);
        const response = await storeAllList(token);
        const response4 = await shopTypeList(token);
        console.log("shopTypeList : ", response4);
        console.log("Store type : ", response);
        setStoreType(response);
        setShopType(response4);
      } catch (error) {
        console.error("Error:", error);
      }
    };
handleFetchAgentList()
fetchEmployeeList()
fetchStoreOwner()
fetchVendorList()
    fetchStoreType();
  }, []);

  useEffect(() => {
    const fetchDoctor = async () => {
      try {
        console.log("token for doctor: ", token);
        const response = await doctorList(token);
        console.log("Doctor : ", response);
        setDoctor(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctor();
  }, []);

  const fields = {
    5: ["bankName", "bankBranch", "bankAccountNumber", "ifscCode", "upiId"],
    4: [
      "profession",
     
      "specialization",
      "degree",
      "numberOfCo",
      "relationWithCo",
      "bankName",
      "bankBranch",
      "bankAccountNumber",
      "ifscCode",
      "upiId",
      "IdentityImage",
    ],
    3: [
       "employeeType",
      
      "profession",
      
      "specialization",
      "degree",
      "numberOfCo",
      "relationWithCo",
      "grossSalary",
      "ctc",
      "bankName",
      "bankBranch",
      "bankAccountNumber",
      "ifscCode",
      "upiId",
      "IdentityImage",
    ],
   // 2: [ "bloodGroup", "prescriptionImage","storeId","referDoctor"],
  2: ["refferedByAgent","refferAgent","refferedByDoctor", "refferDoctor","refferedByEmployee","refferEmployee","refferedByShopOwner","refferShopOwner","refferedByStoreOwner","refferStoreOwner","refferedByVendor","refferVendor", "bloodGroup","prescriptionImage","storeId"],
    8: [
      "shopName",
      "shopAddress",
      "shopOwnerGstNumber",
      "bankName",
      "bankBranch",
      "bankAccountNumber",
      "ifscCode",
      "upiId",
      "latitude",
      "longitude",
      "shopLogoFile",
      "IdentityImage",

    ],
    6: ["storeTypeId",  
      "storeName","storeAddress","storeLogo","storeDocument",
      "aadhaarImageFile",
      "storeOwnerGstNumber","bankAccountNumber",
      "bankBranch","bankName","ifscCode","upiId"],
    7: [
      "vendorCompanyName",
      "vendorGstNumber",
      "bankName",
      "bankBranch",
      "bankAccountNumber",
      "ifscCode",
      "upiId",
      
    ],
    9:["firstName","lastName","mobile","email","dob","gender","address","profileImage"],
    10:["hospitalName","hospitalType","registrationNumber","bankAccountNumber","ifscCode","upiId","bankName","bankBranch"],
    11:['diagnosticCenterName',"registrationNumber","diagnosticCenterAddress"]
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
      console.log("memberList : ", memberList);

      console.log("formData : ", formData);
      console.log("user id : ", userSelectId);
      console.log(formData,userType);
      let referrals=[]


      
if(userType==='2'){
        formDataToSend.append("status","1")
       formDataToSend.append("aadhaarImage",formData.aadhaarImage)
       formDataToSend.append("patientImage",formData.patientImage)
       formDataToSend.append("prescriptionImage",formData.prescriptionImage)
      }
      
      

      Object.entries(formData).forEach(([key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          !(typeof value === "object" && Object.keys(value).length === 0)
        ) {
            if (key === 'refferedBy' || key === 'reffer') return;
          const modifiedKey = ["shopName", "shopAddress","latitude","longitude"].includes(key)
            ? `shopDetails.${key}`
            : key;

          formDataToSend.append(modifiedKey, value);
          
        }
      });

      if (userselectId) {
        formDataToSend.append("commonUserId", userselectId);
      }

      if (formData.IdentityImage) {
        formDataToSend.append("aadhaarImage", formData.IdentityImage);
      }

      if (formData.shopLogoFile) {
        formDataToSend.append("shopLogoFile", formData.shopLogoFile);
      }

       if (formData.refferedBy) {
        formDataToSend.append("prescribedDoctorId", formData.refferedBy);
      }
       if (formData.reffer) {
        formDataToSend.append("referredCategoryId", formData.reffer);
      }

      if (Array.isArray(memberList) && memberList.length > 0) {
        const storeIds = memberList
          .map((item) => item.id ?? item)
          .filter(Boolean);
        storeIds.forEach((id, index) => {
          formDataToSend.append(`shopIds[${index}].shopId`, id);
        });
      }

      if (Array.isArray(productCommission) && productCommission.length > 0) {
        productCommission.forEach((item, index) => {
          if (item.name && item.commission) {
            const prefix = userType === "8" ? "shopDetails." : "";

            formDataToSend.append(
              `${prefix}productCommissions[${index}].productId`,
              item.name
            );
            formDataToSend.append(
              `${prefix}productCommissions[${index}].commission`,
              item.commission
            );
          }
        });
      }
      console.log("userType : ", userType,productCommission,serviceCommission);
      if (Array.isArray(serviceCommission) && serviceCommission.length > 0) {
        serviceCommission.forEach((item, index) => {
          if (item.name && item.commission) {
            const prefix = userType === "8" ? "shopDetails." : "";

            formDataToSend.append(
              `${prefix}serviceCommission[${index}].serviceId`,
              item.name
            );
            formDataToSend.append(
              `${prefix}serviceCommission[${index}].commission`,
              item.commission
            );
          }
        });
      }
      // formDataToSend.append('productCommissions',JSON.stringify(productCommission))
      // formDataToSend.append('serviceCommissions',JSON.stringify(serviceCommission))
      
      for (let [key, value] of formDataToSend.entries()) {
  console.log(key, value);
}  
  console.log("----------------------------- formdata");
  
   Object.entries(formData).forEach(([key, value]) => {
    console.log(key,value);
   })

      


      const response = await categoryAssign(formDataToSend, userType, token);
       console.log(response);


      if (response.status === 200) {
        toast.success("User Allocation added successfully");
        setUserAllocationUpdated((prev) => !prev);
        navigate("/");
      } else if(response.status===400){
        toast.error("Wrong input data format")
        console.log(response);
        
      }
      else {
        toast.error(response.data.message);
         console.log(response);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    let errors = { ...formErrors };

    if (name === "bankAccountNo") {
      if (!/^\d{9,18}$/.test(value)) {
        errors[name] = "Bank account number must be 9 to 18 digits.";
      } else {
        delete errors[name];
      }
    }

    if (name === "upiId") {
      if (!/^[\w.-]+@[\w.-]+$/.test(value)) {
        errors[name] = "Enter a valid UPI ID (e.g., example@upi).";
      } else {
        delete errors[name];
      }
    }

    setFormErrors(errors);
    setFormData({ ...formData, [name]: value });
  };
 const fetchUserCategory = async () => {
      try {
        const response = await userCategory(token);
        console.log("UserAllocation list:", response);
        setUserCategoryList(response);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

     const handleFetchShop=async()=>{
        try {
          const response=await getShopOwnerList(token)
          console.log(response);
          setShopName(response.data)
          
          
        } catch (error) {
          console.log(error);
          
        }
      }
  useEffect(() => {
   
    handleFetchShop()
    fetchUserCategory();
  }, []);

  useEffect(() => {
    const fetchProductList = async () => {
      try {
        const response = await productList(token);
        console.log("product list:", response);
        setProduct(response.products);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchProductList();
  }, []);

  useEffect(() => {
    const fetchServiceList = async () => {
      try {
        const response = await subServiceList(token);
        console.log("service list:", response);
        setService(response);
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchServiceList();
  }, []);

  useEffect(()=>{
  const handleGetMenus=async()=>{
try {
  const response=await getMenuSubmenu(token)
  console.log("list of menus",response);
  if(response.status===200){
    setMenus(response.data.menus)
    setAllPermission(response.data.allPermissions)
     const combinedSubs = response.data.menus.flatMap(menu => menu.submenus);
     setAllSubmenus(combinedSubs)
  }
  
} catch (error) {
  console.log(error);
  
}
  }

  handleGetMenus()
  },[])

  const hasPermission1 = (menuId, permissionId) => { // to check if present or not
  const menu =alowedMenus.find(m => m.menuId === menuId);
  if (!menu) return false;

  return menu.permissionIds.includes(permissionId);
};
 const hasPermission2 = (submenuId, permissionId) => { // to check if present or not
  const menu =alowedSubMenus.find(m => m.submenuId === submenuId);
  if (!menu) return false;

  return menu.permissionIds.includes(permissionId);
};

 const handleAddMenu=async(menuId, permissionId)=>{
  try {
   setAllowedMenus(prev => {
    
    const index = prev.findIndex(item => item.menuId === menuId);

    if (index !== -1) {
      // --- Menu exists: update its permissionIds ---
      const updated = [...prev];
      const perms = new Set(updated[index].permissionIds);

      // toggle permission
      if (perms.has(permissionId)) {
        perms.delete(permissionId);
      } else {
        perms.add(permissionId);
      }

      updated[index].permissionIds = Array.from(perms);
      return updated;

    } else {
      // --- Menu NOT exists: add new menu entry ---
      return [
        ...prev,
        { menuId, permissionIds: [permissionId] }
      ];
    }
  });

    
  } catch (error) {
    console.log(error);
    
  }
 }

  const handleAddSubMenu=async(submenuId, permissionId)=>{
  try {
   setAllowedSubMenus(prev => {
    
    const index = prev.findIndex(item => item.submenuId === submenuId);

    if (index !== -1) {
      // --- Menu exists: update its permissionIds ---
      const updated = [...prev];
      const perms = new Set(updated[index].permissionIds);

      // toggle permission
      if (perms.has(permissionId)) {
        perms.delete(permissionId);
      } else {
        perms.add(permissionId);
      }

      updated[index].permissionIds = Array.from(perms);
      return updated;

    } else {
      // --- Menu NOT exists: add new menu entry ---
      return [
        ...prev,
        { submenuId, permissionIds: [permissionId] }
      ];
    }
  });

    
  } catch (error) {
    console.log(error);
    
  }
 }

 const handleNewRoleSubmit=async()=>{
  try {
    console.log(newRoleName,newDesc,alowedMenus,alowedSubMenus);
    let data={
      categoryname:newRoleName,
      description:newDesc,
      menus:alowedMenus,
      submenus:alowedSubMenus,
      token
    }
    const response=await addNewRole(data)
    console.log("new role add",response);
    if(response.status===200){
      toast.success("New user role Added")
      fetchUserCategory()
      setNewRole(false)
    }
    
    
    
  } catch (error) {
    console.log(error);
    
  }
 }


  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">UserAllocations</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    UserAllocations
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div style={{paddingLeft:"50px"}}>
        <p onClick={()=>navigate("/user")}
        style={{padding:"5px",borderRadius:"8px",cursor:"pointer",border:"0.5px solid gray",width:"fit-content",fontWeight:"500"}}>
          {"<"} Back</p>
        </div>
        <div className="section-body mt-4">
          <div className="container-fluid">
            <form className="card-body" onSubmit={handleSubmit}>
              <div className="tab-content">
                <div className="tab-pane active" id="Student-add">
                  <div className="row clearfix">
                    <div className="col-md-12 col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h3 className="card-title">Basic Information</h3>
                          <div className="card-options ">
                           
                          </div>
                        </div>
                        <div style={{ padding: "0px 20px" }}>
                          
                          <div className="form-group row">
                            <label className="col-md-3 col-form-label">
                              Select User Role{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-md-9">
                              <select
                                className="form-control"
                                value={userType}
                                onChange={(e) => {
                                  setUserType(e.target.value);
                                  setFormData({});
                                }}
                                required
                              >
                                <option value="">Select User Role</option>
                                {userCategorylist.map((category) => (
                                  <option key={category.id} value={category.id}>
                                    {category.categoryname}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          {userType &&
                            fields[userType]?.map(


                              (field) =>{
                                
                                  //  if (
                                  //   field === "storeId" &&
                                  //   formData.employeeType !== "STORE_EMPLOYEE"
                                  // ) {
                                  //   return null;
                                  // }                                
                                 return( <div className="form-group row" key={field}>
                                    <label className="col-md-3 col-form-label">
                                      {field
                                        .replace(/([A-Z])/g, " $1")
                                        .replace(/^./, (str) =>
                                          str.toUpperCase()
                                        )}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <div className="col-md-9">
                                      {field === "vendorImage" ||
                                      field === "IdentityImage" ||
                                      field.includes("Image") || field.includes("Document") ||
                                       field.includes("Logo") ||
                                      field === "shopLogoFile" ? (
                                        <input
                                          type="file"
                                          className="form-control"
                                          name={field}
                                          accept="image/*"
                                          onChange={(e) =>
                                            setFormData({
                                              ...formData,
                                              [field]: e.target.files[0],
                                            })
                                          }
                                          required
                                        />
                                      ) : field === "bloodGroup" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">
                                            Select Blood Group
                                          </option>
                                          <option value="A+">A+</option>
                                          <option value="A-">A-</option>
                                          <option value="B+">B+</option>
                                          <option value="B-">B-</option>
                                          <option value="O+">O+</option>
                                          <option value="O-">O-</option>
                                          <option value="AB+">AB+</option>
                                          <option value="AB-">AB-</option>
                                        </select>
                                      ) : field === "storeTypeId" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">
                                            Select Store Type
                                          </option>
                                          {storeType.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.id)}
                                            >
                                              {type.storeTypeName}
                                            </option>
                                          ))}
                                        </select> )
                                        :field==='employeeType'?(
                                          <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          required
                                        >
                                          <option value="">
                                            Select Employee Type
                                          </option>
                                          <option value="ADMIN_EMPLOYEE">ADMIN_EMPLOYEE</option>
                                          <option value="STORE_EMPLOYEE">STORE_EMPLOYEE</option>
                                        
                                        </select>
                                        )
                                      : field === "refferedBy" ||field==="lastDoctorId"||field==="lastDoctorName"? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          required 
                                        >
                                          <option value="">
                                            Select Doctor
                                          </option>
                                          {refferedBy.map((type) => (
                                            <option
                                              key={type.id}
                                              value={field==="lastDoctorName"?type.firstName:Number(type.id)}
                                            >
                                              {type.firstName}
                                            </option>
                                          ))}
                                        </select>
                                      ):field === "refferedByAgent" || field === "refferedByDoctor"|| field === "refferedByEmployee"|| field === "refferedByShopOwner"|| field === "refferedByStoreOwner"|| field === "refferedByVendor" ? (
                                     <div style={{ display:"flex",}}>

    
                                         <input
                                type="checkbox"
     
                                    name={field}
                                checked={!!formData[field]}
                                onChange={(e) =>
                                 setFormData({
                                    ...formData,
                          [field]: e.target.checked,
                            })
                          }
                         style={{width:"30px",height:"30px"}}
                      />
 
                         </div>
                        )  
                                      
                                      : field === "reffer" ? (
                                        <>
                                          <select
                                            className="form-control"
                                            name={field}
                                            value={formData[field] || ""}
                                            onChange={async (e) => {
                                              const selectedValue =
                                                e.target.value;
                                              setFormData({
                                                ...formData,
                                                [field]: selectedValue,
                                                ...(selectedValue ===
                                                  "Doctor" && {
                                                  chamberName: "",
                                                }),
                                              });
                                              setSelectedReffer(selectedValue);

                                              if (selectedValue) {
                                                await fetchRefferList(
                                                  selectedValue
                                                );
                                              }
                                            }}
                                            required
                                          >
                                            <option value="">
                                              Select Reffer
                                            </option>
                                            {userCategorylist
                                              .filter(
                                                (category) =>
                                                  category.categoryname !==
                                                  "Patient"
                                              )
                                              .map((category) => (
                                                <option
                                                  key={category.id}
                                                  value={Number(category.id)}
                                                >
                                                  {category.categoryname}
                                                </option>
                                              ))}
                                          </select>

                                          {selectedReffer &&
                                            refferList.length > 0 && (
                                              <div className="form-group row mt-2">
                                                <label className="col-md-3 col-form-label">
                                                  Select {selectedReffer}{" "}
                                                  <span className="text-danger">
                                                    *
                                                  </span>
                                                </label>
                                                <div
                                                  className="col-md-9"
                                                  style={{ width: "100%" }}
                                                >
                                                  <select
                                                    className="form-control"
                                                    name="refferedPerson"
                                                    value={
                                                      formData[
                                                        "refferedPerson"
                                                      ] || ""
                                                    }
                                                    onChange={(e) =>
                                                      setFormData({
                                                        ...formData,
                                                        refferedPerson:
                                                          e.target.value,
                                                      })
                                                    }
                                                    required
                                                  >
                                                    <option value="">
                                                      Select {selectedReffer}
                                                    </option>
                                                    {refferList.map(
                                                      (person) => (
                                                        <option
                                                          key={person.id}
                                                          value={person.id}
                                                        >
                                                          {person.firstName}{" "}
                                                          {person.middleName}{" "}
                                                          {person.lastName}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                </div>
                                              </div>
                                            )}

                                          {formData[field] === "Doctor" && (
                                            <div className="form-group row mt-2">
                                              <label className="col-md-3 col-form-label">
                                                Chamber Name
                                                <span className="text-danger">
                                                  *
                                                </span>
                                              </label>
                                              <div className="col-md-9">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="chamberName"
                                                  placeholder="Enter Chamber Name"
                                                  value={
                                                    formData["chamberName"] ||
                                                    ""
                                                  }
                                                  onChange={(e) =>
                                                    setFormData({
                                                      ...formData,
                                                      chamberName:
                                                        e.target.value,
                                                    })
                                                  }
                                                  required
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      ) 
                                      : field === "refferAgent" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                         
                                        >
                                          <option value="">
                                            Select Agent
                                          </option>
                                          {agentListReffer.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.commonUserId)}
                                            >
                                              {type.firstName}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                      : field === "refferDoctor" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          
                                        >
                                          <option value="">
                                            Select Doctor
                                          </option>
                                          {refferedBy.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.commonUserId)}
                                            >
                                              {type.firstName}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                      : field === "refferEmployee" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                         
                                        >
                                          <option value="">
                                            Select Employee
                                          </option>
                                          {employeeRefer.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.commonUserId)}
                                            >
                                              {type.firstName}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                      : field === "refferShopOwner" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                         
                                        >
                                          <option value="">
                                            Select shop Owner
                                          </option>
                                          {shopName.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.commonUserId)}
                                            >
                                              {type?.shopName}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                      : field === "refferStoreOwner" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          
                                        >
                                          <option value="">
                                            Select Store Owner
                                          </option>
                                          {storeOwnerRefer.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.commonUserId)}
                                            >
                                              {type.storeName}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                      : field === "refferVendor" ? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                         
                                        >
                                          <option value="">
                                            Select Vendor
                                          </option>
                                          {vendorRefer.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.commonUserId)}
                                            >
                                              {type.firstName}
                                            </option>
                                          ))}
                                        </select>
                                      )
                                      
                                      :field === "lastChamberName" ||field==="lastChamberId"? (
                                        <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          required>
                                          <option value="">
                                            Select Doctor
                                          </option>
                                          {shopName.map((type) => (
                                            <option
                                              key={type.id}
                                              value={field === "lastChamberName"?type.shopName:Number(type.id)}
                                            >
                                              {type.shopName}
                                            </option>
                                          ))}
                                        </select>
                                      ):
                                      field === "storeId" ? (
                                          <select
                                          className="form-control"
                                          name={field}
                                          value={formData[field] || ""}
                                          onChange={handleChange}
                                          
                                        >
                                          <option value="">
                                            Select Store 
                                          </option>
                                          {storeOwnerRefer.map((type) => (
                                            <option
                                              key={type.id}
                                              value={Number(type.id)}
                                            >
                                              {type.storeName}
                                            </option>
                                          ))}
                                        </select>
                                      ):
                                       (
                                        <>
                                          <input
                                            type={
                                              field.includes("email")
                                                ? "email"
                                                : field.includes("dob")||field.includes("date")||field.includes("Date")
                                                ? "date"
                                                : field.includes(
                                                    "phoneNumber"
                                                  ) || field.includes("number")
                                                ? "number"
                                                : "text"
                                            }
                                            className={`form-control ${
                                              (field === "bankAccountNo" &&
                                                formData[field] &&
                                                !/^\d{9,18}$/.test(
                                                  formData[field]
                                                )) ||
                                              (field === "upiId" &&
                                                formData[field] &&
                                                !/^[\w.-]+@[\w.-]+$/.test(
                                                  formData[field]
                                                )) ||
                                              (field === "ifscCode" &&
                                                formData[field] &&
                                                !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(
                                                  formData[field]
                                                ))
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                            name={field}
                                            placeholder={`Enter ${field
                                              .replace(/([A-Z])/g, " $1")
                                              .toLowerCase()}`}
                                            value={formData[field] || ""}
                                            onChange={(e) =>
                                              setFormData({
                                                ...formData,
                                                [field]:
                                                  field === "ifscCode"
                                                    ? e.target.value.toUpperCase()
                                                    : e.target.value,
                                              })
                                            }
                                            required
                                          />

                                          {field === "bankAccountNo" &&
                                            formData[field] &&
                                            !/^\d{9,18}$/.test(
                                              formData[field]
                                            ) && (
                                              <div className="invalid-feedback">
                                                Bank account number must be 9 to
                                                18 digits.
                                              </div>
                                            )}

                                          {field === "upiId" &&
                                            formData[field] &&
                                            !/^[\w.-]+@[\w.-]+$/.test(
                                              formData[field]
                                            ) && (
                                              <div className="invalid-feedback">
                                                Enter a valid UPI ID (e.g.,
                                                example@upi).
                                              </div>
                                            )}

                                          {field === "ifscCode" &&
                                            formData[field] &&
                                            !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(
                                              formData[field]
                                            ) && (
                                              <div className="invalid-feedback">
                                                Enter a valid IFSC code (e.g.,
                                                SBIN0001234).
                                              </div>
                                            )}
                                        </>
                                      )}
                                    </div>
                                  </div>)
                                
                                    }
                                
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {doctorChember.includes(userType) && (
                <div className="card commission-card">
                  <div className="card-header product-header">
                    <h3 className="card-title">Chamber</h3>
                  </div>
                  <div className="card-body">
                    {memberList.map((member, index) => (
                      <div
                        className="form-group row commission-row"
                        key={index}
                        style={{ flexDirection: "row", marginBottom: "10px" }}
                      >
                        <div className="col-md-5">
                          <select
                            className="form-control"
                            value={member.shopName}
                            onChange={(e) =>
                              handleMemberChange(index, e.target.value)
                            }
                          >
                            <option value="">Select Shop</option>
                            {shopType.map((store) => (
                              <option key={store.id} value={store.id}>
                                {store.shopName}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="col-md-2 d-flex align-items-center">
                          <button
                            type="button"
                            className="btn btn-success btn-circle"
                            onClick={() => handleAddFieldMember()}
                          >
                            +
                          </button>
                          {index > 0 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-circle"
                              onClick={() => handleRemoveFieldMember(index)}
                            >
                              -
                            </button>
                          )}
                        </div>
                      </div>
                    ))}

                    {memberList.length === 0 && (
                      <button
                        type="button"
                        className="btn btn-primary add-first-btn"
                        onClick={() => handleAddFieldMember("member")}
                      >
                        +
                      </button>
                    )}
                  </div>
                </div>
              )}

              {userTypesWithCommission.includes(userType) && (
                <div className="commission-container">
                  <div className="card commission-card">
                    <div className="card-header product-header">
                      <h3 className="card-title">Product Commission</h3>
                    </div>
                    <div className="card-body">
                      {productCommission?.map((item, index) => (
                        <div
                          className="form-group row commission-row"
                          key={index}
                          style={{ flexDirection: "row" }}
                        >
                          <div className="col-md-5">
                            <select
                              className="form-control"
                              value={item.name}
                              onChange={(e) =>
                                handleFieldChange(
                                  "product",
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Product</option>
                              {product?.map((product) => (
                                <option key={product.id} value={product?.id}>
                                  {product?.productName}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-4">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter % Commission"
                              value={item.commission}
                              onChange={(e) =>
                                handleFieldChange(
                                  "product",
                                  index,
                                  "commission",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          <div className="col-md-3 d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-success btn-circle"
                              onClick={() => handleAddField("product")}
                            >
                              +
                            </button>
                            {index > 0 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-circle"
                                onClick={() =>
                                  handleRemoveField("product", index)
                                }
                              >
                                -
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      {productCommission.length === 0 && (
                        <button
                          type="button"
                          className="btn btn-primary add-first-btn"
                          onClick={() => handleAddField("product")}
                        >
                          +
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="card commission-card">
                    <div className="card-header service-header">
                      <h3 className="card-title">Service Commission</h3>
                    </div>
                    <div className="card-body">
                      {serviceCommission.map((item, index) => (
                        <div
                          className="form-group row commission-row"
                          key={index}
                          style={{ flexDirection: "row" }}
                        >
                          <div className="col-md-5">
                            <select
                              className="form-control"
                              value={item.name}
                              onChange={(e) =>
                                handleFieldChange(
                                  "service",
                                  index,
                                  "name",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Service</option>
                              {service.map((service) => (
                                <option key={service.id} value={service?.id}>
                                  {service?.serviceName}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-4">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter % Commission"
                              value={item.commission}
                              onChange={(e) =>
                                handleFieldChange(
                                  "service",
                                  index,
                                  "commission",
                                  e.target.value
                                )
                              }
                            />
                          </div>

                          <div className="col-md-3 d-flex align-items-center">
                            <button
                              type="button"
                              className="btn btn-success btn-circle"
                              onClick={() => handleAddField("service")}
                            >
                              +
                            </button>
                            {index > 0 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-circle"
                                onClick={() =>
                                  handleRemoveField("service", index)
                                }
                              >
                                -
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      {serviceCommission.length === 0 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-primary add-first-btn"
                            onClick={() => handleAddField("service")}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div
                className="col-sm-12"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!userType}
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default UserAllocation;
